import { useMediaQuery } from "react-responsive";
import { Button, Flex, Image, Layout, theme } from "antd";

import {
  isOrganizationOneascent,
  isOrganizationRivershares,
} from "../../../../../../../../utils/helper/specialized";

import GetAdvice from "../../../../layout/image/GetAdvice";
import { ReactComponent as OneAscentSlogan } from "../../../../../../image/slogan_light.svg";

const ProposalHeader = ({ organization, openModal }) => {
  const { token } = theme.useToken();
  const isSmallScreen = useMediaQuery({ maxWidth: token.screenMDMin });

  return (
    <Layout.Header
      style={{
        background: token.proposal_header_background,
        backdropFilter: token.proposal_header_background_filter,
        height: token.proposal_header_height,
        minHeight: "fit-content",
        padding: token.proposal_header_padding,
        width: `calc(100vw - ${isSmallScreen ? 0 : token.sidebar__width}px)`,
      }}
    >
      {isOrganizationOneascent(organization) && (
        <Flex align="center" justify="space-between">
          <Image id="headerLogo" preview={false} src={token.logo_src} />
          {!isSmallScreen && <OneAscentSlogan id="oneascentSlogan" />}
        </Flex>
      )}
      {isOrganizationRivershares(organization) && (
        <Flex>
          <Image
            id="headerLogo"
            preview={false}
            src={token.logo_src}
            width={160}
          />
        </Flex>
      )}
      {!organization && (
        <Flex justify="space-between">
          <Image
            id="headerLogo"
            preview={false}
            src={token.logo_src}
            width={160}
          />
          <Button
            type="secondary"
            shape="round"
            style={{
              width: 40,
              padding: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            onClick={() => openModal("openModalAskAdvice")}
          >
            <GetAdvice />
          </Button>
        </Flex>
      )}
    </Layout.Header>
  );
};

export default ProposalHeader;
